import React, { useState } from "react";
import addNewUser from "../methods/api/addNewUser";
import "./addNewUser.css";

const AddNewUser = ({ fetchUsersList }) => {
  const [formData, setFormData] = useState({
    username: "",
    role: "user",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validatePassword = () => {
    return formData.password === formData.confirmPassword;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword()) {
      alert("Hasła się nie zgadzają!")
      return;
    }

    await addNewUser(formData).then((status) => {
      if (status === 201) {
        fetchUsersList();
        setFormData({
          username: "",
          role: "user",
          password: "",
          confirmPassword: "",
        });
      }
      else if (status === 409) {
        alert("Użytkownik o podanej nazwie już istnieje!")
      }
      else {
        alert("Operacja nie powiodła się!")
      }
    });
  };

  return (
    <div className="registration-form-wrapper">
      <form onSubmit={handleSubmit} className="registration-form">
        <div className="register-input-field">
          <label htmlFor="username">Nazwa użytkownika:</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>
        <div className="register-input-field">
          <label htmlFor="role">Rola:</label>
          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
          >
            <option value="user">Użytkownik</option>
            <option value="admin">Administrator</option>
          </select>
        </div>
        <div className="register-input-field">
          <label htmlFor="password">Hasło:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>{" "}
        <div className="register-input-field">
          <label htmlFor="confirmPassword">Powtórz hasło:</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">DODAJ UŻYTKOWNIKA</button>
      </form>
    </div>
  );
};

export default AddNewUser;
